import React from 'react';
import AnchorMenuChoice, {
  TAnchorMenuChoice,
  TAnchorMenuChoiceProps,
} from '../AnchorMenuChoice/AnchorMenuChoice';
import ButtonMenuChoice, {
  TButtonMenuChoice,
  TButtonMenuChoiceProps,
} from '../ButtonMenuChoice/ButtonMenuChoice';

export type TMenuChoice = TAnchorMenuChoice | TButtonMenuChoice;
export type TMenuChoiceProps = TAnchorMenuChoiceProps | TButtonMenuChoiceProps;

const isPropsForAnchor = (props: TMenuChoiceProps): props is TAnchorMenuChoiceProps => {
  return !!props.href;
};

const AnchorOrButtonMenuChoice = (props: TMenuChoiceProps) => {
  const isAnchor = isPropsForAnchor(props);
  // eslint-disable-next-line react/jsx-props-no-spreading
  return isAnchor ? <AnchorMenuChoice {...props} /> : <ButtonMenuChoice {...props} />;
};

export default AnchorOrButtonMenuChoice;
